import React from 'react';
import { formatBrlInput, parseBrlInputToCents } from './invoiceMoney.mjs';
import InvoiceInfo from './InvoiceInfo';
import './InvoiceTransportationOptions.css';

export default function InvoiceTransportationOptions({ options, onChange, disabled = false }) {
  if (!options.chargeTransportationVoucher) return null;
  const source = options.transportationVoucherSource === 'registered' ? 'registered' : 'general';
  return <div className="invoice-transportation-options" style={{ gridColumn: '1 / -1' }}>
    <label><span>Origem do VT</span><select value={source} disabled={disabled} onChange={event => onChange('transportationVoucherSource', event.target.value)}>
      <option value="registered">VT cadastrado</option><option value="general">VT geral</option>
    </select></label>
    {source === 'general' && <label><span>VT geral por jovem<InvoiceInfo label="VT geral" description="Aplica o mesmo valor somente aos jovens selecionados com Cobrar VT = Sim no cadastro, substituindo o valor individual nesta emissão. O desconto de VT mantém a configuração individual." /></span>
      <input aria-label="VT geral por jovem" disabled={disabled} inputMode="numeric" value={(Number(options.generalTransportationVoucherCents || 0) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
        onChange={event => onChange('generalTransportationVoucherCents', parseBrlInputToCents(formatBrlInput(event.target.value)))} />
    </label>}
  </div>;
}
